import { BracketType, GetPhaseBracketQuery } from '@plvs/graphql/generated'
import { useGeneralEsportAdapter } from '@plvs/respawn/features/esport/creator'
import { useAppLocationFn, useUserIdentityFn } from '@plvs/client-data/hooks'
import { BracketMatch } from '@plvs/respawn/components/bracket/Bracket'
import { makeStyles } from '@material-ui/core'
import {
  BracketPhase,
  getRoundsFromMatches,
} from '@plvs/respawn/containers/bracket/hooks/useProcessedRounds.utils'

type UseProcessedRoundsProps = {
  bracketData: GetPhaseBracketQuery | undefined
  esportSlug: string
}

const useStyles = makeStyles((theme) => ({
  icon: {
    width: '32px',
    height: '32px',
    marginRight: theme.spacing(1),
    verticalAlign: 'middle',
  },
}))

export function useProcessedRounds({
  bracketData,
  esportSlug,
}: UseProcessedRoundsProps): {
  processedRounds: BracketMatch[][]
  processedUpperRounds: BracketMatch[][]
  processedLowerRounds: BracketMatch[][]
  processedFinalRounds: BracketMatch[][]
} {
  const styles = useStyles()
  const isDoubleElimination =
    bracketData?.getBracketByPhaseId?.type === BracketType.DoubleElimination

  const appLocation = useAppLocationFn()
  const { isLoggedIn } = useUserIdentityFn()
  const { hasSeries, rating, isYouthProgram } =
    useGeneralEsportAdapter(esportSlug)

  const matches =
    bracketData?.getBracketByPhaseId?.bracketMatches
      .slice()
      .sort((a, b): number => {
        const aIsUpper = a.bracketIndex.includes(BracketPhase.Upper)
        const bIsUpper = b.bracketIndex.includes(BracketPhase.Upper)
        if (aIsUpper && bIsUpper) {
          return a.ordinalNumber - b.ordinalNumber
        }
        if (aIsUpper) {
          return -1
        }
        if (bIsUpper) {
          return 1
        }
        return a.ordinalNumber - b.ordinalNumber
      }) ?? []

  return getRoundsFromMatches({
    matches,
    isLoggedIn,
    hasSeries,
    rating,
    isYouthProgram,
    isDoubleElimination,
    appLocation,
    styles,
  })
}
